import { useState } from "react";
import { CLICK_EVENT, requestNextStep } from "../StepPopper";
import { CodeEntryHelperArea } from "./CodeEntryHelperArea";
import { CodeEntryAreaSwitch } from "./CodeEntryAreaSwitch";

export const CodeEntryHelper = (props : { chars : any[], link? : string, open? : boolean , show? : boolean}) => {
  const [showArea, setShowArea] = useState(false);
  if (!props.show) { return null; }
  if (props.open && !showArea) {
    setShowArea(true);
  }

  const switchArea = () => {
    requestNextStep(CLICK_EVENT, "keyboard-help-switched")
    setShowArea(!showArea);
  }

  return (<>
    { !showArea && <CodeEntryAreaSwitch isVisible={switchArea} />} 
    { showArea && <CodeEntryHelperArea chars={props.chars} link={props.link} open={props.open} close={switchArea} /> }
  </>);
}
